import _toConsumableArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
/** Returns an array of calendar weeks from an array of calendar months. */
export function getWeeks(months) {
  var initialWeeks = [];
  return months.reduce(function (weeks, month) {
    return [].concat(_toConsumableArray(weeks), _toConsumableArray(month.weeks));
  }, initialWeeks);
}